export default {
  root: {
    fontSize: "24px",
    alignItems: "center",
    padding: "10px 16px",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
    },
  },
  message: {
    padding: "0px",
  },
  icon: {
    padding: "0px",
    "& svg": {
      height: "33px",
      width: "33px",
      ['@media (max-width: 768px)']: {
        height: "28px",
        width: "28px",
      },
    }
  },
  action: {
    "& .MuiSvgIcon-root": {
      height: "24px",
      width: "24px",
    }
  }
};